{{ score.type }}: {{ score.current }}/{{ score.final }} <span class="lap-weather-divider"></span>
<vn-icon size="10" name="sports-sb-weather-{{ score.weather }}-i"></vn-icon>
